/**
 * BOG Checkout — Smartdoor
 * NOTE: loaded with defer, so DOM is already parsed when this runs.
 * Do NOT wrap in DOMContentLoaded — it may have already fired.
 */

(function () {
  'use strict';

  var form = document.getElementById('bog-customer-form');
  if (!form) {
    console.warn('[BOG] bog-customer-form not found on page');
    return;
  }

  console.log('[BOG] Checkout JS init OK');

  var paymentOptions = document.querySelectorAll('.bog-payment-option');
  var bankPanel      = document.getElementById('bog-bank-panel');
  var submitBtn      = document.getElementById('bog-submit-btn');
  var submitText     = submitBtn ? submitBtn.querySelector('.bog-submit-text') : null;
  var alertBox       = document.getElementById('bog-alert');

  var selectedMethod = null;

  // ── Payment option selection ─────────────────────────────────────────────
  paymentOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      var radio = this.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        selectedMethod = radio.value;
      }

      paymentOptions.forEach(function (o) { o.classList.remove('is-selected'); });
      this.classList.add('is-selected');

      if (selectedMethod === 'transfer') {
        bankPanel && bankPanel.classList.add('is-visible');
      } else {
        bankPanel && bankPanel.classList.remove('is-visible');
      }

      var labels = {
        transfer:    'გადარიცხვის დეტალები',
        bnpl:        'ნაწილ-ნაწილ — გაგრძელება',
        installment: 'განვადება — გაგრძელება',
      };
      if (submitText && selectedMethod) {
        submitText.textContent = labels[selectedMethod];
      }
      hideAlert();
    });
  });

  // ── Clear errors on input ────────────────────────────────────────────────
  form.querySelectorAll('.bog-checkout__input, .bog-checkout__select').forEach(function (el) {
    el.addEventListener('input', function () { clearFieldError(this); });
    el.addEventListener('change', function () { clearFieldError(this); });
  });

  // ── Form submit ──────────────────────────────────────────────────────────
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    console.log('[BOG] Form submitted. Selected method:', selectedMethod);
    hideAlert();

    if (!validateForm()) {
      console.log('[BOG] Validation failed');
      return;
    }

    if (!selectedMethod) {
      showAlert('გთხოვთ აირჩიოთ გადახდის მეთოდი');
      return;
    }

    if (!document.getElementById('bog-terms').checked) {
      showAlert('გთხოვთ დაეთანხმოთ პირადი მონაცემების დამუშავების პირობებს');
      return;
    }

    if (selectedMethod === 'transfer') {
      saveLead();
      bankPanel && bankPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }

    saveLead();
    startBogFlow(selectedMethod === 'bnpl');
  });

  // ── BOG flow ─────────────────────────────────────────────────────────────
  function startBogFlow(isBnpl) {
    var config = window.bogCheckoutConfig;
    console.log('[BOG] Config:', config);

    if (!config || !config.herokuUrl) {
      showAlert('სერვერის URL არ არის კონფიგურირებული');
      return;
    }

    var totalEl = document.getElementById('bog-cart-total');
    var totalAmount = totalEl ? parseFloat(totalEl.value) : 0;

    if (!totalAmount) {
      showAlert('კალათა ცარიელია');
      return;
    }

    // ── Path A: BOG SDK modal ──────────────────────────────────────────────
    if (typeof BOG !== 'undefined' && BOG.Calculator && typeof BOG.Calculator.open === 'function') {
      console.log('[BOG] Opening SDK modal. Amount:', totalAmount, 'BNPL:', isBnpl);
      setLoading(true);

      BOG.Calculator.open({
        amount: totalAmount,
        bnpl: isBnpl ? true : false,

        onClose: function () {
          console.log('[BOG] Modal closed');
          setLoading(false);
        },

        onRequest: function (selected, successCb, closeCb) {
          console.log('[BOG] onRequest selected:', selected);
          doCheckoutRequest(totalAmount, selected.month, isBnpl ? 'bnpl' : 'installment', selected.discount_code, successCb, closeCb);
        },

        onComplete: function (result) {
          console.log('[BOG] onComplete:', result);
          if (result && result.redirectUrl) {
            window.location.href = result.redirectUrl;
          }
          return false;
        },
      });

    } else {
      // ── Path B: Direct API (no SDK / SDK not loaded) ───────────────────
      console.warn('[BOG] SDK not available — using direct redirect flow');
      setLoading(true);

      // Use a sensible default: 3 months for installment, 4 for bnpl
      var defaultMonth = isBnpl ? 4 : 3;
      var payType = isBnpl ? 'bnpl' : 'installment';

      doCheckoutRequest(totalAmount, defaultMonth, payType, null,
        function (orderId) {
          // successCb — SDK not present so orderId won't help; server should have sent redirect too
          console.log('[BOG] orderId from direct call:', orderId);
        },
        function () {
          setLoading(false);
          showAlert('BOG-ის სისტემასთან კავშირი ვერ მოხდა. სცადეთ ხელახლა.');
        }
      );
    }
  }

  function doCheckoutRequest(amount, month, payType, discountCode, successCb, closeCb) {
    var customerInfo = getCustomerInfo();
    var cartDataEl = document.getElementById('bog-cart-data');
    var cartData = { items: [] };
    try { if (cartDataEl) cartData = JSON.parse(cartDataEl.textContent); } catch (e) { console.warn('[BOG] cart data parse error', e); }

    var herokuUrl = window.bogCheckoutConfig.herokuUrl.replace(/\/$/, ''); // strip trailing slash

    console.log('[BOG] POST to', herokuUrl + '/bog-checkout');

    fetch(herokuUrl + '/bog-checkout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        price:        amount,
        loanMonth:    month,
        paymentType:  payType,
        discountCode: discountCode,
        cartItems:    cartData.items,
        customerInfo: customerInfo,
      }),
    })
      .then(function (res) {
        console.log('[BOG] Server status:', res.status);
        return res.json();
      })
      .then(function (data) {
        console.log('[BOG] Server response:', data);
        setLoading(false);

        if (data.redirect) {
          // Direct redirect (works with or without SDK)
          window.location.href = data.redirect;
        } else if (data.orderId) {
          successCb && successCb(data.orderId);
        } else {
          var msg = data.error || 'გადახდის სისტემამ შეცდომა დააბრუნა';
          showAlert(msg);
          closeCb && closeCb();
        }
      })
      .catch(function (err) {
        console.error('[BOG] Fetch error:', err);
        setLoading(false);
        showAlert('სერვერთან კავშირი ვერ მოხდა: ' + err.message);
        closeCb && closeCb();
      });
  }

  // ── Helpers ──────────────────────────────────────────────────────────────
  function getCustomerInfo() {
    return {
      fName:   val('bog-fname'),
      lName:   val('bog-lname'),
      phone:   val('bog-phone'),
      email:   val('bog-email'),
      address: val('bog-address'),
    };
  }

  function saveLead() {
    var config = window.bogCheckoutConfig;
    if (!config || !config.herokuUrl) return;

    var info = getCustomerInfo();
    var cartDataEl = document.getElementById('bog-cart-data');
    var cartData = { items: [], total: 0 };
    try { if (cartDataEl) cartData = JSON.parse(cartDataEl.textContent); } catch (e) {}

    fetch(config.herokuUrl.replace(/\/$/, '') + '/save-lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerInfo:  info,
        paymentMethod: selectedMethod,
        cartTotal:     cartData.total,
        cartItems:     cartData.items,
      }),
    }).then(function () {
      console.log('[BOG] Lead saved');
      var toast = document.getElementById('bog-toast');
      if (toast) {
        toast.style.display = 'block';
        setTimeout(function () { toast.style.display = 'none'; }, 4000);
      }
    }).catch(function (e) {
      console.warn('[BOG] Lead save failed:', e.message);
    });
  }

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function validateForm() {
    var valid = true;
    var fields = [
      { id: 'bog-fname',   msg: 'სახელი სავალდებულოა' },
      { id: 'bog-lname',   msg: 'გვარი სავალდებულოა' },
      { id: 'bog-phone',   msg: 'ტელეფონი სავალდებულოა' },
      { id: 'bog-address', msg: 'მისამართი სავალდებულოა' },
    ];

    fields.forEach(function (f) {
      var el = document.getElementById(f.id);
      if (!el || !el.value.trim()) {
        setFieldError(el, f.msg);
        valid = false;
      }
    });

    if (!valid) {
      var first = form.querySelector('.bog-checkout__input.has-error, .bog-checkout__select.has-error');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      showAlert('გთხოვთ შეავსოთ ყველა სავალდებულო ველი');
    }

    return valid;
  }

  function setFieldError(el, msg) {
    if (!el) return;
    el.classList.add('has-error');
    var errEl = el.parentElement && el.parentElement.querySelector('.bog-checkout__field-error');
    if (errEl) { errEl.textContent = msg; errEl.classList.add('visible'); }
  }

  function clearFieldError(el) {
    el.classList.remove('has-error');
    var errEl = el.parentElement && el.parentElement.querySelector('.bog-checkout__field-error');
    if (errEl) errEl.classList.remove('visible');
  }

  function showAlert(msg) {
    if (!alertBox) return;
    alertBox.textContent = msg;
    alertBox.classList.add('is-visible');
    alertBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideAlert() {
    if (alertBox) alertBox.classList.remove('is-visible');
  }

  function setLoading(on) {
    if (!submitBtn) return;
    if (on) { submitBtn.classList.add('is-loading'); submitBtn.disabled = true; }
    else    { submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; }
  }

})();
